module.exports = __webpack_public_path__ + "static/img/announcement_banner.76f8de9f.png";